import { render } from "./CircuitDiagram.vue?vue&type=template&id=327920ff&scoped=true&ts=true"
import script from "./CircuitDiagram.vue?vue&type=script&lang=ts"
export * from "./CircuitDiagram.vue?vue&type=script&lang=ts"

import "./CircuitDiagram.vue?vue&type=style&index=0&id=327920ff&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327920ff"]])

export default __exports__